import React, { useState, useEffect } from "react";
import { Popover, Button, InputNumber } from "antd";
import axios from "axios";

axios.defaults.baseURL = "https://api.wonderbits.cn/var";
/* eslint-disable */
function MyOption(props: any) {
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [itemList, setItemList] = useState<string[]>([]);

  const getData = async () => {
    const response = await axios.get(
      `/history/preview?name=${props.keyWord}&page=${page}&per_page=${perPage}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );

    if (response.data.data) {
      const list = response.data.data.map((data: any) => {
        return data.value;
      });
      setItemList(list);
    }
  };

  useEffect(() => {
    getData();
  }, [page, perPage]);

  const content = (
    <div
      style={{ width: "100%", height: "300px" }}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div style={{ width: "100%", height: "250px", overflowY: "scroll" }}>
        {itemList.map((item) => {
          return <div key={item}>{item}</div>;
        })}
      </div>
      <Button
        disabled={page === 1}
        onClick={() => {
          setPage((page) => page - 1);
        }}
        size="small"
      >
        上一页
      </Button>
      <span> {page} </span>
      <Button
        onClick={() => {
          setPage((page) => page + 1);
        }}
        size="small"
        disabled={page !== 1 && Number(perPage) !== itemList.length}
      >
        下一页
      </Button>
      <div style={{ margin: "5px 5px" }}>
        每页显示
        {
          <InputNumber
            min={1}
            max={30}
            defaultValue={10}
            onChange={(value) => {
              if (value) setPerPage(value);
            }}
            size={"small"}
          />
        }
        条
      </div>
    </div>
  );

  const onVisibleChange = (visible: boolean) => {
    if (visible) {
      getData();
    }
  };
  return (
    <div>
      <Popover
        placement="right"
        title={"预览"}
        content={content}
        trigger="hover"
        mouseEnterDelay={1}
        onVisibleChange={onVisibleChange}
      >
        <div style={{ width: "100%" }}>{props.keyWord}</div>
      </Popover>
    </div>
  );
}

export default MyOption;
